module.exports = __webpack_public_path__ + "static/featured-video-a88de43f12f64eb7d42d7aac7e69b652.mp4";